import CulturalDiversityImage from "../assets/NewsImages/CulturalDiversity/culturalDiversityMain.png";
import cul1 from "../assets/NewsImages/CulturalDiversity/cul1.png";
import cul2 from "../assets/NewsImages/CulturalDiversity/cul2.png";
import cul3 from "../assets/NewsImages/CulturalDiversity/cul3.png";
import cul4 from "../assets/NewsImages/CulturalDiversity/cul4.png";
import cul5 from "../assets/NewsImages/CulturalDiversity/cul5.png";
import cul6 from "../assets/NewsImages/CulturalDiversity/cul6.png";
import cul7 from "../assets/NewsImages/CulturalDiversity/cul7.png";

import BookCharacterImage from "../assets/NewsImages/BookCharacterDay/bookMain.jpg";
import book1 from "../assets/NewsImages/BookCharacterDay/book1.jpg";
import book2 from "../assets/NewsImages/BookCharacterDay/book2.jpg";
import book3 from "../assets/NewsImages/BookCharacterDay/book3.jpg";
import book4 from "../assets/NewsImages/BookCharacterDay/book4.jpg";
import book5 from "../assets/NewsImages/BookCharacterDay/book5.jpg";
import book6 from "../assets/NewsImages/BookCharacterDay/book6.jpg";
import book7 from "../assets/NewsImages/BookCharacterDay/book7.jpg";
import book8 from "../assets/NewsImages/BookCharacterDay/book8.jpg";
import book9 from "../assets/NewsImages/BookCharacterDay/book9.jpg";

import PFCImage from "../assets/NewsImages/PFC/pfcMain.jpg";
import pfc1 from "../assets/NewsImages/PFC/pfc1.jpg";
import pfc2 from "../assets/NewsImages/PFC/pfc2.jpg";
import pfc3 from "../assets/NewsImages/PFC/pfc3.jpg";
import pfc4 from "../assets/NewsImages/PFC/pfc4.jpg";
import pfc5 from "../assets/NewsImages/PFC/pfc5.jpg";
import pfc6 from "../assets/NewsImages/PFC/pfc6.jpg";
import pfc7 from "../assets/NewsImages/PFC/pfc7.jpg";
import pfc8 from "../assets/NewsImages/PFC/pfc8.jpg";
import pfc9 from "../assets/NewsImages/PFC/pfc9.jpg";

import ChocolateMain from "../assets/NewsImages/Chocolate/chocolateMain.png";
import chocolate1 from "../assets/NewsImages/Chocolate/chocolate1.png";
import chocolate2 from "../assets/NewsImages/Chocolate/chocolate2.png";
import chocolate3 from "../assets/NewsImages/Chocolate/chocolate3.png";
import chocolate4 from "../assets/NewsImages/Chocolate/chocolate4.png";
import chocolate5 from "../assets/NewsImages/Chocolate/chocolate5.png";
import chocolate6 from "../assets/NewsImages/Chocolate/chocolate6.png";
import chocolate7 from "../assets/NewsImages/Chocolate/chocolate7.png";

import CommunityMain from "../assets/NewsImages/Community/communityMain.jpg";
import community1 from "../assets/NewsImages/Community/community1.jpg";
import community2 from "../assets/NewsImages/Community/community2.jpg";
import community3 from "../assets/NewsImages/Community/community3.jpg";
import community4 from "../assets/NewsImages/Community/community4.jpg";
import community5 from "../assets/NewsImages/Community/community5.jpg";
import community6 from "../assets/NewsImages/Community/community6.jpg";
import community7 from "../assets/NewsImages/Community/community7.jpg";
import community8 from "../assets/NewsImages/Community/community8.jpg";
import community9 from "../assets/NewsImages/Community/community9.jpg";

import SummerCampMain from "../assets/NewsImages/SummerCamp/summer_camp.jpeg"

import GmhlMain from "../assets/NewsImages/GMHL/gmhl10.jpeg"
import gmhl1 from "../assets/NewsImages/GMHL/gmhl1.jpeg";
import gmhl2 from "../assets/NewsImages/GMHL/gmhl2.jpeg";
import gmhl3 from "../assets/NewsImages/GMHL/gmhl3.jpeg";
import gmhl4 from "../assets/NewsImages/GMHL/gmhl4.jpeg";
import gmhl5 from "../assets/NewsImages/GMHL/gmhl5.jpeg";
import gmhl6 from "../assets/NewsImages/GMHL/gmhl6.jpeg";
import gmhl7 from "../assets/NewsImages/GMHL/gmhl7.jpeg";
import gmhl8 from "../assets/NewsImages/GMHL/gmhl8.jpeg";
import gmhl9 from "../assets/NewsImages/GMHL/gmhl9.jpeg";

import EduSummitMain from "../assets/NewsImages/EduSummit/summit1.jpeg"
import summit1 from "../assets/NewsImages/EduSummit/summit1.jpeg";
import summit2 from "../assets/NewsImages/EduSummit/summit2.jpeg";
import summit3 from "../assets/NewsImages/EduSummit/summit3.jpeg";
import summit4 from "../assets/NewsImages/EduSummit/summit4.jpeg";
import summit5 from "../assets/NewsImages/EduSummit/summit5.jpeg";

export const news = [
  {
    slug: "cultural-diversity-day",
    image: CulturalDiversityImage,
    date: "5th March, 2024",
    title: "CULTURAL DIVERSITY DAY",
    description:
      "This year's Cultural Diversity Day at our school, held on March 5th, 2024, was a vibrant celebration of unity and cultural heritage. Throughout the day, students and staff came together to honor the rich tapestry of ethnic groups represented within our school community.",

    images: [cul1, cul2, cul3, cul4, cul5, cul6, cul7],
    links: [
      "https://www.facebook.com/reel/421081663646210/",
      "https://www.facebook.com/share/8rMXbE9iENHyjbU1/",
    ],
  },
  {
    slug: "book-character-day",
    image: BookCharacterImage,
    date: "12th March, 2024",
    title: "BOOK CHARACTER DAY",
    description:
      "To celebrate our students' love for storytelling and comic books, we organized a lively event known as Book Character Day. This special day, held on March 12th, 2024, saw our school transformed into a vibrant showcase of beloved literary and comic book heroes.",

    images: [book1, book2, book3, book4, book5, book6, book7, book8, book9],
    links: [
      "https://www.facebook.com/share/gUQkptH38Bqznf4Z/",
      "https://www.facebook.com/share/v/gYaZvjpwADEzMYsG/",
    ],
  },
  {
    slug: "parent-facilitator-conference",
    image: PFCImage,
    date: "11th March, 2024",
    title: "PARENT FACILITATOR CONFERENCE & BOOK FAIR",
    description:
      "To demonstrate our commitment to parental involvement in their children's education, we host an annual event known as the Parent-Facilitator Conference. This year’s event took place on Monday, March 11th, 2024, to serve as an opportunity for parents to actively engage with facilitators to gain insights into their children's academic progress and well-being.",

    images: [pfc1, pfc2, pfc3, pfc4, pfc5, pfc6, pfc7, pfc8, pfc9],
    links: [
      "https://www.facebook.com/100069959117752/posts/pfbid033dv7VPbieShkTTQtPhGesh2NoNbCSDZ2toj1rfctEFVGWDzPp9uvNweVMJA52kXbl/",
    ],
  },
  {
    slug: "ghana-chocolate-day",
    image: ChocolateMain,
    date: "14th February, 2024",
    title: "GHANA CHOCOLATE DAY",
    description:
      "To demonstrate our commitment to parental involvement in their children's education, we host an annual event known as the Parent-Facilitator Conference. This year’s event took place on Monday, March 11th, 2024, to serve as an opportunity for parents to actively engage with facilitators to gain insights into their children's academic progress and well-being.",

    images: [
      chocolate1,
      chocolate2,
      chocolate3,
      chocolate4,
      chocolate5,
      chocolate6,
      chocolate7,
      
    ],
    links: [
      "https://www.facebook.com/100069959117752/posts/pfbid02BWCQKMnGooevHhdshdaEo6TN93D4kCEAthSWQMnb6tjuad71sUcuGBKCyimGPE8tl/",
    ],
  },
  {
    slug: "community-helpers-day",
    image: CommunityMain,
    date: "23rd February, 2024",
    title: "COMMUNITY HELPERS DAY",
    description:
      "On February 23rd, 2024, the Foundation class held its inaugural event, aptly titled Community Helpers Day. This special occasion aimed to express gratitude to the various community helpers in our country and underscore the importance of their invaluable contributions.,monstrate our commitment to parental involvement in their children's education, we host an annual event known as the Parent-Facilitator Conference. This year’s event took place on Monday, March 11th, 2024, to serve as an opportunity for parents to actively engage with facilitators to gain insights into their children's academic progress and well-being.",

    images: [
      community1,
      community2,
      community3,
      community4,
      community5,
      community6,
      community7,
      community8,
      community9,
    ],
    links: [
      "https://www.facebook.com/share/DeTrAzDYbL4radQH/",
      "https://www.facebook.com/share/8rMXbE9iENHyjbU1/",
    ],
  },

  {
    slug: "summer-camp",
    image: SummerCampMain,
    date: "Monday 29th July to Friday 16th August, 2024",
    title: "SUMMER CAMP",
    description:
      "On February 23rd, 2024, the Foundation class held its inaugural event, aptly titled Community Helpers Day. This special occasion aimed to express gratitude to the various community helpers in our country and underscore the importance of their invaluable contributions.,monstrate our commitment to parental involvement in their children's education, we host an annual event known as the Parent-Facilitator Conference. This year’s event took place on Monday, March 11th, 2024, to serve as an opportunity for parents to actively engage with facilitators to gain insights into their children's academic progress and well-being.",
    

  },
  {
    slug: "education-summit",
    image: EduSummitMain,
    date: "Friday 5th to Sunday 7th July, 2024",
    title: "EDUCATION SUMMIT",
    description:
      "From time immemorial, education has played a significant role in shaping nations. In the 21st century, education has seen numerous positive changes that have brought about great transformation worldwide, especially in Ghana. ",
      images: [
        summit1,
        summit2,
        summit3,
        summit4,
        summit5,
        
      ],
  },
  {
    slug: "ghana-my-homeland",
    image: GmhlMain,
    date: "Friday 14th June, 2024",
    title: "GHANA MY HOMELAND",
    description:
      "As part of their Oral & Auditory lessons on Ghana and its history, the Reception and Year 1 classes held an event dubbed 'Ghana My Homeland' on Friday, June 14th, 2024, to showcase their knowledge about Ghana and celebrate its forefathers and their immense contributions in the fight for independence. ",
      images: [
        gmhl1,
        gmhl2,
        gmhl3,
        gmhl4,
        gmhl5,
        gmhl6,
        gmhl7,
        gmhl8,
        gmhl9,
      ],
  },
];
